import { render } from "./CommonSwitch.vue?vue&type=template&id=0933150f&scoped=true&ts=true"
import script from "./CommonSwitch.vue?vue&type=script&lang=ts"
export * from "./CommonSwitch.vue?vue&type=script&lang=ts"

import "./CommonSwitch.vue?vue&type=style&index=0&id=0933150f&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0933150f"]])

export default __exports__